import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";

/**
 * Live TikTok creator_info for the composer. Per TikTok's Content Sharing
 * Guidelines this MUST be fetched fresh each time the post screen renders
 * (no caching) because account-level settings (privacy options, comment/duet/
 * stitch availability, posting limits) can change between sessions.
 */
export interface TikTokCreatorInfo {
  creatorNickname: string;
  creatorUsername: string;
  creatorAvatarUrl: string;
  privacyLevelOptions: string[];
  commentDisabled: boolean;
  duetDisabled: boolean;
  stitchDisabled: boolean;
  maxVideoPostDurationSec: number;
}

export function useTikTokCreatorInfo(forUserId: string | undefined, enabled: boolean) {
  const qs = forUserId ? `?forUserId=${encodeURIComponent(forUserId)}` : "";
  return useQuery<TikTokCreatorInfo>({
    // Lives under the scheduler router so it shares organic.scheduler.manage perms.
    queryKey: ["/api/scheduler/tiktok/creator-info", forUserId ?? null],
    queryFn: () =>
      apiRequest("GET", `/api/scheduler/tiktok/creator-info${qs}`) as Promise<TikTokCreatorInfo>,
    enabled,
    staleTime: 0,
    gcTime: 0,
    retry: false,
    refetchOnMount: "always",
  });
}
